// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "close-1vwu_";
export { _1 as "__esModule", _2 as "mobile", _3 as "close" }
export default { "__esModule": _1, "mobile": _2, "close": _3 }
